export default {
  adFlyerHost: window.appConfig.apps.adflyer,
  vmsHost: window.appConfig.apps.vms,
};
